class CalloutsBar extends HTMLElement {
  #resizeObserver = null;

  connectedCallback() {
    this.#setup();
    this.#resizeObserver = new ResizeObserver(() => this.#setup());
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #setup() {
    const track = this.querySelector('[data-track]');
    const group = this.querySelector('[data-group]');
    if (!track || !group) return;

    this.removeAttribute('data-marquee');
    this.style.removeProperty('--callouts-group-width');

    requestAnimationFrame(() => {
      const containerWidth = this.offsetWidth;
      const groupWidth = group.offsetWidth;

      if (groupWidth > containerWidth) {
        this.style.setProperty('--callouts-group-width', `${groupWidth}px`);
        this.setAttribute('data-marquee', '');
      }
    });
  }
}

customElements.define('callouts-bar', CalloutsBar);
